// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/common/v1/http_request.proto" (package "bianka.common.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../../../google/protobuf/wrappers";
import { FloatValue } from "../../../google/protobuf/wrappers";
/**
 * Next serial number to be used: 26
 *
 * @generated from protobuf message bianka.common.v1.HttpRequest
 */
export interface HttpRequest {
    /**
     * Request's user agent
     *
     * @generated from protobuf field: string user_agent = 1;
     */
    userAgent: string;
    /**
     * The ip the request came from
     *
     * @generated from protobuf field: string ip = 2;
     */
    ip: string;
    /**
     * Request's method
     *
     * @generated from protobuf field: string method = 3;
     */
    method: string;
    /**
     * Request's url
     *
     * @generated from protobuf field: string url = 4;
     */
    url: string;
    /**
     * Request's referrer's url
     *
     * @generated from protobuf field: string referrer = 5;
     */
    referrer: string;
    /**
     * Request's mobile app version
     *
     * @generated from protobuf field: string mobile_app_version = 6;
     */
    mobileAppVersion: string;
    /**
     * Indicates if the request came from a bot
     *
     * @generated from protobuf field: bool is_bot = 7;
     */
    isBot: boolean;
    /**
     * Indicates if the request is an ajax request
     *
     * @generated from protobuf field: bool is_xhr = 8;
     */
    isXhr: boolean;
    /**
     * The city the request came from
     *
     * @generated from protobuf field: string city = 9;
     */
    city: string;
    /**
     * The country the request came from
     *
     * @generated from protobuf field: string country = 10;
     */
    country: string;
    /**
     * The country code the request came from
     *
     * @generated from protobuf field: string country_code = 11;
     */
    countryCode: string;
    /**
     * The subdivision the request came from
     *
     * @generated from protobuf field: string subdivision = 12;
     */
    subdivision: string;
    /**
     * The subdivision code the request came from
     *
     * @generated from protobuf field: string subdivision_code = 13;
     */
    subdivisionCode: string;
    /**
     * The continent the request came from
     *
     * @generated from protobuf field: string continent = 14;
     */
    continent: string;
    /**
     * The time zode the request came from
     *
     * @generated from protobuf field: string time_zone = 15;
     */
    timeZone: string;
    /**
     * The latitude the request came from
     *
     * @generated from protobuf field: google.protobuf.FloatValue latitude = 16;
     */
    latitude?: FloatValue;
    /**
     * The longitude the request came from
     *
     * @generated from protobuf field: google.protobuf.FloatValue longitude = 17;
     */
    longitude?: FloatValue;
    /**
     * Request's browser language
     *
     * @generated from protobuf field: string browser_language = 18;
     */
    browserLanguage: string;
    /**
     * Request's os
     *
     * @generated from protobuf field: string os = 19;
     */
    os: string;
    /**
     * Request's os version
     *
     * @generated from protobuf field: string os_version = 20;
     */
    osVersion: string;
    /**
     * Request's device
     *
     * @generated from protobuf field: string device = 21;
     */
    device: string;
    /**
     * Request's browser
     *
     * @generated from protobuf field: string browser = 22;
     */
    browser: string;
    /**
     * Request's browser version
     *
     * @generated from protobuf field: string browser_version = 23;
     */
    browserVersion: string;
    /**
     * Response's time
     *
     * @generated from protobuf field: google.protobuf.FloatValue response_time = 24;
     */
    responseTime?: FloatValue;
    /**
     * Response's status
     *
     * @generated from protobuf field: google.protobuf.StringValue status = 25;
     */
    status?: StringValue;
}
// @generated message type with reflection information, may provide speed optimized methods
class HttpRequest$Type extends MessageType<HttpRequest> {
    constructor() {
        super("bianka.common.v1.HttpRequest", [
            { no: 1, name: "user_agent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "referrer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mobile_app_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_bot", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "is_xhr", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "country_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "subdivision", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "subdivision_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "continent", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "latitude", kind: "message", T: () => FloatValue },
            { no: 17, name: "longitude", kind: "message", T: () => FloatValue },
            { no: 18, name: "browser_language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "os", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "os_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "device", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "browser", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "browser_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "response_time", kind: "message", T: () => FloatValue },
            { no: 25, name: "status", kind: "message", T: () => StringValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message bianka.common.v1.HttpRequest
 */
export const HttpRequest = new HttpRequest$Type();
